import React from 'react'
import FavoriteDialog from '../../../../../../src/component/main-ui/right-toolbar/pop-out/save-boundary'
import './index.css'

const FavoriteLocation = (props) => {
  const closeFavoriteLocation = () => {
    props.closeFavoriteMenu()
  }
  return (
    <div className='favorite-left-toolbar-container'>
      <div style={{ width: '90%' }}>
        <FavoriteDialog leftToolBar={true} hidePopout={closeFavoriteLocation} />
      </div>
    </div>
  )
}

export default FavoriteLocation